import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9005/api'
// const API_ROOT = 'https://egranting-uat.thaihealth.or.th:9001/api'

//Progress ReportForm
export const getProgressReportForm = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/progress-report/${projectProgressId}`

  return doGet(url)
}

//Progress Managercomment
export const getProgressManagercomment = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/managercomment/${projectProgressId}`
  return doGet(url)
}

export const updateProgressManagercomment = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/managercomment/${projectProgressId}`
  return doPut(url, request)
}

//Progress Acknowledgement
export const getProgressAcknowledgement = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/acknowledgement/${projectProgressId}`
  return doGet(url)
}

export const updateProgressAcknowledgement = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/acknowledgement/${projectProgressId}`
  return doPut(url, request)
}

//Progress Introduction
export const getProgressIntroduction = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/introduction/${projectProgressId}`
  return doGet(url)
}

export const updateProgressIntroduction = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/introduction/${projectProgressId}`
  return doPut(url, request)
}

//Progress Operationalprogress
export const getProgressOperationalprogress = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/operationalprogress/${projectProgressId}`
  return doGet(url)
}

export const updateProgressOperationalprogress = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/operationalprogress/${projectProgressId}`
  return doPut(url, request)
}

//Progress ProgessActivity
export const getProgessActivity = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/activity/${projectProgressId}`
  return doGet(url)
}

export const updateProgessActualActivity = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/actual-activity/${projectProgressId}`
  return doPut(url, request)
}

export const saveProgessActivity = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/activity/${projectProgressId}`
  return doPost(url, request)
}

export const updateProgessActivity = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/activity/${projectProgressId}`
  return doPut(url, request)
}

//Progress Percentofprogress
export const getProgressPercentofprogress = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/percentofprogress/${projectProgressId}`
  return doGet(url)
}

export const updateProgressPercentofprogress = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/percentofprogress/${projectProgressId}`
  return doPut(url, request)
}

//Progress Problemsandsolutions
export const getProgressProblemsandsolutions = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/problemsandsolutions/${projectProgressId}`
  return doGet(url)
}

export const updateProgressProblemsandsolutions = (
  projectVersionId,
  projectProgressId,
  request
) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/problemsandsolutions/${projectProgressId}`
  return doPut(url, request)
}

//Progress Riskassessment
export const getProgressRiskassessment = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/riskassessment/${projectProgressId}`
  return doGet(url)
}

export const updateProgressRiskassessment = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/riskassessment/${projectProgressId}`
  return doPut(url, request)
}

//Progress Worksummary
export const getProgressWorksummary = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/worksummary/${projectProgressId}`
  return doGet(url)
}

export const updateProgressWorksummary = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/worksummary/${projectProgressId}`
  return doPut(url, request)
}

//Progress Outcome
export const getProgressOutcome = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/outcome/${projectProgressId}`
  return doGet(url)
}

export const updateProgressOutcome = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/outcome/${projectProgressId}`
  return doPut(url, request)
}

export const saveSingegleProgressOutcome = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/outcome/${projectProgressId}/single`
  return doPut(url, request)
}

export const deleteProgressOutcome = (id) => {
  const url = `${API_ROOT}/progress/outcome/single/${id}`
  return doDelete(url)
}

//Progress Result
export const getProgressResult = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/result/${projectProgressId}`
  return doGet(url)
}

export const updateProgressResult = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/result/${projectProgressId}`
  return doPut(url, request)
}

export const saveSingegleProgressResult = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/result/${projectProgressId}/single`
  return doPut(url, request)
}

export const deleteProgressResult = (type, id) => {
  // const url = `${API_ROOT}/progress/result/single/${type}/${id}`
  const url = `${API_ROOT}/progress/result/single/${id}`
  return doDelete(url)
}

//Progress ProgressProduct
export const getProgressProduct = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/product/${projectProgressId}`
  return doGet(url)
}

export const updateProgressProduct = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/product/${projectProgressId}`
  return doPut(url, request)
}

//Progress ProgressIndicator
export const getProgressIndicator = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/indicator/${projectProgressId}`
  return doGet(url)
}

export const updateProgressIndicator = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/indicator/${projectProgressId}`
  return doPut(url, request)
}

export const saveSingegleProgressIndicator = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/indicator/${projectProgressId}/single`
  return doPut(url, request)
}

export const deleteProgressIndicator = (id) => {
  const url = `${API_ROOT}/progress/indicator/single/${id}`
  return doDelete(url)
}

export const getProgressLinkageIndicators = (projectProgressId, projectIndicatorId) => {
  const url = `${API_ROOT}/progress/${projectProgressId}/progress-linkage-indicator/${projectIndicatorId}`
  return doGet(url)
}

export const saveProgressLinkageIndicators = (request, projectProgressId, projectIndicatorId) => {
  const url = `${API_ROOT}/progress/${projectProgressId}/progress-linkage-indicator/${projectIndicatorId}`
  return doPut(url, request)
}

//Progress ProgressSearchTag
export const getProgressSearchTag = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/searchtag/${projectProgressId}`
  return doGet(url)
}

export const updateProgressSearchTag = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/searchtag/${projectProgressId}`
  return doPut(url, request)
}

//Progress ProgressAsset
export const getProgressAsset = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/asset/${projectProgressId}`
  return doGet(url)
}

//Attachments
export const getAttachments = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}`
  return doGet(url)
}

export const getAttachmentsByFileId = (projectVersionId, projectProgressId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}/${fileId}`
  return doGet(url)
}
export const getDownload = (projectVersionId, projectProgressId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}/${fileId}/download`
  return doDownload(url)
}

export const saveAttachments = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}`
  return doPostFiles(url, request)
}

export const updateAttachments = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}/${request.id}`
  return doPut(url, request)
}

export const deleteAttachments = (projectVersionId, projectProgressId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/attachments/${projectProgressId}/${fileId}`
  return doDelete(url)
}

//Progress ProgressFeedback
export const getProgressFeedback = (projectVersionId, projectProgressId, projectFeedbackId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/feedback/${projectProgressId}/${projectFeedbackId}`
  return doGet(url)
}

export const updateProgressFeedback = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/feedback/${projectProgressId}`
  return doPut(url, request)
}

export const saveProgressFeedback = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/feedback/${projectProgressId}`
  return doPost(url, request)
}

export const deleteProgressFeedback = (projectVersionId, projectProgressId, projectFeedbackId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/feedback/${projectProgressId}/${projectFeedbackId}`
  return doDelete(url)
}

//Progress TargetGroup
export const getTargetGroup = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/target-group/${projectProgressId}`
  return doGet(url)
}

export const updateTargetGroup = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/target-group/${projectProgressId}`
  return doPut(url, request)
}

export const sendFeedback = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/send-feedback/${projectProgressId}`
  return doPut(url, request)
}

export const downloadProgressFile = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/progress/form/${projectProgressId}`
  return doDownload(url)
}

//DOL
export const getDolExternal = (projectCode, pageSize, pageNo) => {
  const url = `${API_ROOT}/external/dol/list-media/${projectCode}/${pageSize}/${pageNo}`
  return doGet(url)
}

export const getDolDownload = (projectVersionId, projectProgressId, refId) => {
  // /api/progress/{projectVersionId}/attachment-dol/{projectProgressId}/download
  // const url = `${API_ROOT}/progress/${projectVersionId}/attachment-dol/${projectProgressId}/download?url=${xurl}`
  // /api/progress/{projectVersionId}/attachment-dol/{projectProgressId}/download/{refId}
  const url = `${API_ROOT}/progress/${projectVersionId}/attachment-dol/${projectProgressId}/download/${refId}`
  return doDownload(url)
}

export const saveDolAttachment = (projectVersionId, projectProgressId, request) => {
  // /api/progress/{projectVersionId}/attachment-dol/{projectProgressId}
  const url = `${API_ROOT}/progress/${projectVersionId}/attachment-dol/${projectProgressId}`
  return doPost(url, request)
}

export const deleteDolAttachment = (projectVersionId, projectProgressId, request) => {
  // /api/progress/{projectVersionId}/attachment-dol/{projectProgressId}/{refId}
  const url = `${API_ROOT}/progress/${projectVersionId}/attachment-dol/${projectProgressId}/delete`
  return doPost(url, request)
}

// IAM
export const getIamExternal = (projectCode) => {
  // /api/external/iam/resource-center/{projectCode}
  const url = `${API_ROOT}/external/iam/resource-center/${projectCode}`
  return doGet(url)
}

//คัดลอกรายงานครั้งก่อนหน้า
export const copyPreviousProgress = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/copy-previous-progress/${projectProgressId}`

  return doPost(url)
}

export const copyToNextProgress = (projectVersionId, projectProgressId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/copy-to-next-progress/${projectProgressId}`
  return doPut(url)
}
